import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { AgentIsland } from '@/components/AgentIsland';
import { ArtifactLayer } from '@/components/ArtifactLayer';
import { AnonSignInPrompt } from '@/components/AnonSignInPrompt';
import { CommandQueueProcessor } from '@/components/CommandQueueProcessor';
import { useAppSession } from '@/contexts/SessionContext';
import { useAuth } from '@/hooks/useAuth';
import { useAnonSession } from '@/hooks/useAnonSession';
import { useAnonHome } from '@/hooks/useAnonHome';
import { usePaperThemeActive } from '@/hooks/useThemeFlag';
import { PaperChatLayout } from '@/components/paper/PaperChatLayout';

export const ChatLayout = () => {
  const isPaper = usePaperThemeActive();
  if (isPaper) return <PaperChatLayout />;
  return <ChatLayoutLegacy />;
};

const ChatLayoutLegacy = () => {
  const { session, artifacts } = useAppSession();
  const { chat, chatHistory } = session;
  const auth = useAuth();
  const { onHome, anonPrompt } = useAnonHome();

  const anonHasStartedSession = useMemo(
    () =>
      !auth.isAuthenticated &&
      !!chat.activeChat &&
      chat.activeChat.timeline.some((item) => item.kind === 'user'),
    [auth.isAuthenticated, chat.activeChat],
  );

  useAnonSession({
    isAuthenticated: auth.isAuthenticated,
    signIn: auth.signIn,
    anonHasStartedSession,
  });

  return (
    <>
      <CommandQueueProcessor handleSend={session.handleSend} stop={chat.stop} />

      <Outlet />

      <ArtifactLayer artifacts={artifacts} />

      {!artifacts.landscapeArtifact && (auth.isAuthenticated || chat.activeChatId) && (
        <AgentIsland
          sessions={chatHistory.sessions}
          isAuthenticated={auth.isAuthenticated}
          onHome={onHome}
          artifactVisible={artifacts.hasArtifact}
          artifactOpen={artifacts.artifactOpen}
          onArtifactToggle={() => artifacts.setArtifactOpen((v) => !v)}
        />
      )}

      {anonPrompt.visible && (
        <AnonSignInPrompt
          onSignIn={anonPrompt.onSignIn}
          onContinue={anonPrompt.onContinue}
          onCancel={anonPrompt.onCancel}
        />
      )}
    </>
  );
};
